__turbopack_context__.v({
  "name": "StickyATC-module__y8UzYa__name",
  "price": "StickyATC-module__y8UzYa__price",
  "root": "StickyATC-module__y8UzYa__root",
  "variants": "StickyATC-module__y8UzYa__variants",
  "visible": "StickyATC-module__y8UzYa__visible",
});
